<template>
  <div class="column full-height">
    <div class="row justify-center">
      <img :src="headerImg" alt="postcode" class="col-xs-4 col-sm-3 col-md-2" />
      <p class="text-weight-medium full-width text-center q-mt-lg">
        {{ header }}
      </p>
      <p class="full-width text-center q-mt-sm">
        {{ body }}
      </p>
      <SAIFormError class="q-mt-md" v-if="error" />
      <SAIInput
        :disable="disable || loading"
        :error="error"
        class="q-mt-md col-xs-12 col-sm-8 col-md-6 col-lg-5 col-xl-4"
        placeholder="Enter Postcode"
        :large="true"
        :value="user.postcode"
        @input="$emit('update:user', { ...user, postcode: $event })"
      />
    </div>
    <QSpace />
    <div class="row justify-center q-mt-lg">
      <SAIBtn
        :disable="disable || loading"
        :loading="loading"
        :label="nextLabel"
        icon-right="eva-arrow-forward-outline"
        :large="true"
        no-caps
        @click="$emit('next')"
      />
    </div>
  </div>
</template>

<script>
import { QSpace } from 'quasar';
import SAIInput from '../../atom/sai-input';
import SAIBtn from '../../atom/sai-btn';
import SAIFormError from '../../molecule/sai-form-error';

export default {
  name: 'SaiUserProfileStepPostcode',
  props: {
    headerImg: String,
    header: {
      type: String,
      default: 'Your postcode'
    },
    body: {
      type: String,
      default: 'Your location could save you money on your car insurance.'
    },
    nextLabel: {
      type: String,
      default: 'Next'
    },
    disable: Boolean,
    loading: Boolean,
    error: Boolean,
    user: {
      type: Object,
      default: () => ({
        postcode: undefined
      })
    }
  },
  components: {
    SAIInput,
    SAIBtn,
    SAIFormError,
    QSpace
  }
};
</script>
